import { Component, ChangeDetectorRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChooseModalParam } from 'src/app/models/choose-modal-param';

@Component({
    templateUrl: './delete-modal.html',
    standalone: false
})
export class DeleteModalComponent {
  message = 'LAYOUT.ARE_YOU_SURE';

  constructor(public dialogRef: MatDialogRef<DeleteModalComponent>, private _cdr: ChangeDetectorRef, @Inject(MAT_DIALOG_DATA) data: {text: string}) {

    // parametros que vai receber
    if(data?.text)
    {
      this.message = data.text;
    }
   }

}
